const breakpoints = {
    xs: { max: 630 },
    sm: { max: 950, min: 631 },
    md: { max: 1370, min: 951 },
    lg: { max: 1920, min: 1371 },
    xl: { min: 1921 },
};

const inRange = (value, min, max) =>
    (!min || min <= value) && (!max || max >= value);

export default function getViewSize() {
    const { innerWidth } = window;

    return Object.entries(breakpoints)
        .filter(([name, { min, max }]) => inRange(innerWidth, min, max))
        .map(([name]) => name)
        .join();
}
